import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {BaseService} from '../base/service.base';
import {Apointment} from '../models/apointment.model';

@Injectable()
export class AgendaService extends BaseService {
  private _apointments$: BehaviorSubject<Apointment[]>;
  private _dataStore: {
    apointments: Apointment[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {apointments: []};
    this._apointments$ = <BehaviorSubject<Apointment[]>>new BehaviorSubject([]);
  }

  get apointments$() {
    return this._apointments$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/agenda${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.apointments = result;
      this._apointments$.next(this._dataStore.apointments);
    }, error => console.error('Could not load apointments.'));
  }

  public load(id: any) {
    this._http.get(`${this.baseApiUrl}/agenda/${id}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      let notFound = true;

      this._dataStore.apointments.forEach((item, index) => {
        if (item._id === result._id) {
          this._dataStore.apointments[index] = result;
          notFound = false;
        }
      });

      if (notFound) {
        this._dataStore.apointments.push(result);
      }

      this._apointments$.next(this._dataStore.apointments);
    }, error => console.error('Could not load apointment.'));
  }

  public create(apointment: Apointment) {
    this._http.post(`${this.baseApiUrl}/agenda`, JSON.stringify(apointment), {headers: postContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.apointments.push(result);
      this._apointments$.next(this._dataStore.apointments);
    }, error => console.error('Could not create apointment.'));
  }

  public update(apointment: Apointment) {
    this._http.put(`${this.baseApiUrl}/agenda/${apointment._id}`, JSON.stringify(apointment), {headers: postContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.apointments.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.apointments[i] = result;
        }
      });

      this._apointments$.next(this._dataStore.apointments);
    }, error => console.error('Could not update apointment.'));
  }

  public remove(apointmentId: string) {
    this._http.delete(`${this.baseApiUrl}/agenda/${apointmentId}`).subscribe(response => {
      this._dataStore.apointments.forEach((t, i) => {
        if (t._id === apointmentId) {
          this._dataStore.apointments.splice(i, 1);
        }
      });

      this._apointments$.next(this._dataStore.apointments);
    }, error => console.error('Could not delete apointment.'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/agenda.service.ts